<div class="flex">
  <div class="w-full">
    <span [ngClass]="{ 'p-float-label': showFloatLabel }">
      <!-- the regex pattern is invalid if input contains nothing but whitespaces -->
      <input
        #stringInput
        pInputText
        [placeholder]="showFloatLabel ? '' : placeholder"
        type="text"
        pattern="^(\s+\S+\s*)*(?!\s).*$"
        [formControl]="control"
        class="w-full"
        [ngClass]="inputClass"
        [class.ng-invalid]="mandatory && !control.value"
        (keyup.enter)="stringInput.validity.valid ? emitEnter() : ''"
        (keyup.esc)="emitEscape()"
        (keydown.tab)="emitTab()"
        (focus)="handleOnFocus()"
        (blur)="handleBlur($event)"
        [required]="mandatory"
        [jmlAutoSelect]="autoSelect"
      />
      <label *ngIf="!!placeholder && showFloatLabel" [for]="stringInput.id">{{ placeholder }}</label>
    </span>
  </div>
  <ng-content></ng-content>
</div>
